import AuthBase from "../AuthBase";
import {
    Box,
    Checkbox,
    FormControlLabel,
    SpeedDial,
    SpeedDialAction,
    SpeedDialIcon,
} from "@mui/material";
import {useEffect, useRef, useState} from "react";
import DinoDataGrid from "../../components/DataGrid";
import Typography from "@mui/material/Typography";
import DeleteIcon from '@mui/icons-material/Delete';
import DetailDrawer from "../../components/DetailDrawer";
import ReservationDetail from "./ReservationDetail";
import DinoDialog from "../../components/Dialog";
import DialogDetail from "./DialogDetail";
import Button from "@mui/material/Button";
import Calendar from "../../components/calendar/Calendar";
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';
import ReserveBase from "../../components/reserve/ReserveBase";
import SelectOnlyDate from "../../components/reserve/SelectOnlyDate";
import Loading from "../../components/Loading";
import {ReservationProvider} from "../../context/ReservationContext";
import {useSnackbar} from "notistack";
import IconButton from "@mui/material/IconButton";
import InvoiceAdditionalData from "./components/InvoiceAdditionalData";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import useReservationQueries from "../../hooks/queries/useReservationQueries";
import {downloadFileFromResponse} from "../../utils/misc";
import {getColumns} from "../../components/reserve/reservationTable";


const Reservations = () => {
    const snackbar = useSnackbar()
    const [newDate, setNewDate] = useState({})
    const [displayReservations, setDisplayReservations] = useState([])
    const [detailView, setDetailView] = useState(false)
    const [reservation, setReservation] = useState({})
    const [deleteOpen, setDeleteOpen] = useState(false)
    const [listView, setListView] = useState(true)
    const [onlyPending, setOnlyPending] = useState(false)
    const [reservationStatus, setReservationStatus] = useState('accepted')
    const [newReservationOpen, setNewReservationOpen] = useState(false)
    const [modifyTimeOpen, setModifyTimeOpen] = useState(false)
    const [billingOpen, setBillingOpen] = useState(false)
    const {
        reservationsBusinessQuery,
        deleteReservationMutation,
        acceptReservationMutation,
        rejectReservationMutation,
        createInvoiceMutation,
        updateReservationMutation,
        sendInvoiceMutation,
        downloadInvoiceMutation,
    } = useReservationQueries();


    const { data: reservations, isPending: reservationsLoading } = reservationsBusinessQuery;

    const findReservation = id => reservations.find(r => r.id === id)

    const deleteReservation = (id) => deleteReservationMutation.mutate(id, {
        onSuccess: response => {
            setDetailView(false)
        }
    })

    const updateDate = (id, date, end_date, slot) => updateReservationMutation.mutate({id, date, end_date, slot}, {
        onSuccess: response => {
            setDetailView(false)
            setModifyTimeOpen(false)
        }
    })

    const accept = id => acceptReservationMutation.mutate(id, {
        onSuccess: response => {
            setDetailView(false)
        }
    })

    const reject = id => rejectReservationMutation.mutate(id, {
        onSuccess: response => {
            setDetailView(false)
        }
    })

    const createInvoice = (id, data) => createInvoiceMutation.mutate({id, data}, {
        onSuccess: response => {
            setBillingOpen(false)
        }
    })

    const downloadInvoice = (id, doc_id) => downloadInvoiceMutation.mutate({id, doc_id}, {
        onSuccess: response => {
            downloadFileFromResponse(response, 'invoice.pdf');
            setDetailView(false);
        },
    })

    const sendInvoice = (id, doc_id) => sendInvoiceMutation.mutate({id, doc_id})


    const onDeleteClicked = (id) => {
        setReservation(findReservation(id))
        setDeleteOpen(true)
    }

    const onDetailClicked = (id) => {
        setReservation(findReservation(id))
        setDetailView(true)
    }


    const billingRef = useRef(null)
    const buttons = [{
        name: 'Új foglalás hozzáadása',
        props: {
            variant: 'contained',
            endIcon: <AddCircleRoundedIcon/>,
            onClick: () => setNewReservationOpen(true)
        }
    }]

    const filterButtons = [{
        name: 'Aktív foglalások', props: {
            variant: reservationStatus === 'accepted' ? 'contained' : 'text',
            onClick: () => setReservationStatus('accepted')
        }
    }, {
        name: 'Korábbi foglalások', props: {
            variant: reservationStatus === 'accepted' ? 'text' : 'contained',
            onClick: () => setReservationStatus('rejected')
        }
    }
    ]

    const filterButtonsMobile = [{
        name: 'Aktív', props: {
            variant: reservationStatus === 'accepted' ? 'contained' : 'text',
            size: 'small',
            onClick: () => setReservationStatus('accepted')
        }
    }, {
        name: 'Korábbi', props: {
            variant: reservationStatus === 'accepted' ? 'text' : 'contained',
            size: 'small',
            onClick: () => setReservationStatus('rejected')
        }
    }
    ]


    useEffect(() => {
        if (reservations) filterDisplayReservations()
        // eslint-disable-next-line
    }, [reservationStatus, onlyPending, reservations])

    const filterDisplayReservations = () => {
        // setLoading(prev => ({...prev, filter: true}))
        if (reservationStatus === 'accepted') setDisplayReservations([...reservations?.filter(r => ['pending', !onlyPending && 'accepted'].includes(r.display_status))])
        else setDisplayReservations([...reservations?.filter(r => [!onlyPending && 'rejected'].includes(r.display_status))])
        // setLoading(prev => ({...prev, filter: false}))
    }



    const dialogActions = <>
        <Button variant='outlined' style={{padding: 15}} onClick={() => setDeleteOpen(false)}>Mégsem</Button>
        <Button variant='contained' style={{padding: 15}} onClick={() => {
            setDeleteOpen(false)
            deleteReservation(reservation?.id)
        }} endIcon={<DeleteIcon/>}>Foglalás törlése</Button>
    </>

    const modifyActions = <>
        <Button variant='outlined' style={{padding: 15}} onClick={() => setModifyTimeOpen(false)}>Mégsem</Button>
        <Button variant='contained' style={{padding: 15}} onClick={() => {
            const {id, date, end_date, slot} = newDate
            updateDate(id, date, end_date, slot)
        }} endIcon={<CalendarTodayRoundedIcon/>}>Időpont módosítása</Button>
    </>

    const billingActions = <>
        <Button variant='outlined' style={{padding: 15}} onClick={() => setBillingOpen(false)}>Mégsem</Button>
        <Button variant='contained' style={{padding: 15}} onClick={() => {
            const data = billingRef.current.getData()
            if (data) {
                createInvoice(reservation?.id, data)

            }

        }} endIcon={<ReceiptRoundedIcon/>}>Számla kiállítása</Button>
    </>

    if (reservationsLoading) return <Loading isLoading />

    return <AuthBase
        label='Foglalások'
        buttons={buttons}
        filterButtons={filterButtons}
        filterButtonsMobile={filterButtonsMobile}
    >
        <div className="reservations-main">
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 2, // Optional: Adds spacing between items
                    marginBottom: 2
                }}
            >
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1, // Optional: Adds spacing between items
                }}>
                    <IconButton
                        variant='outlined'
                        onClick={() => setListView(!listView)}
                    >
                        {listView ? <CalendarTodayRoundedIcon sx={{color: '#5EB885'}}/> :
                            <FormatListBulletedRoundedIcon sx={{color: '#5EB885'}}/>}
                    </IconButton>

                    <Typography
                        variant='subtitle2'
                        style={{color: '#536B74'}}
                    >
                        {displayReservations.length} db
                    </Typography>
                </Box>

                <FormControlLabel
                    control={
                        <Checkbox
                            sx={{color: '#6F8E9A'}}
                            checked={onlyPending}
                            onChange={(event) => setOnlyPending(event.target.checked)}
                        />
                    }
                    label={
                        <Typography variant='caption' color='#6F8E9A'>
                            csak elfogadásra várók
                        </Typography>
                    }
                />
            </Box>

            {
                listView ?
                    <DinoDataGrid columns={getColumns(onDeleteClicked, onDetailClicked)} rows={displayReservations}/>
                    :
                    <div className='white-card-calendar'>
                        <Calendar items={displayReservations.map(r => ({
                            onClick: () => {
                                setReservation(r)
                                setDetailView(true)
                            },
                            ...r
                        }))}
                        />
                    </div>
            }
        </div>

        <DetailDrawer open={detailView} setOpen={setDetailView}>
            <ReservationDetail
                r={reservation}
                close={() => setDetailView(false)}
                accept={accept}
                destroy={() => setDeleteOpen(true)}
                decline={reject}
                modify={() => setModifyTimeOpen(true)}
                create_invoice={() => setBillingOpen(true)}
                download_invoice={downloadInvoice}
                send_invoice={sendInvoice}/>
        </DetailDrawer>

        <DinoDialog title='Biztos törölni szeretnéd az alábbi foglalást?'
                    subtitle='Csak abban az esetben törölj időpontot ha  azt a klienssel előre leegyeztetted!'
                    open={deleteOpen}
                    handleClose={() => setDeleteOpen(false)}
                    actions={dialogActions}>
            <DialogDetail r={reservation}/>
        </DinoDialog>

        <DinoDialog open={newReservationOpen}
                    title='Új foglalás hozzáadása'
                    subtitle=''
                    handleClose={() => setNewReservationOpen(false)}>
            <ReservationProvider setNewReservationOpen={setNewReservationOpen}>
                <ReserveBase/>
            </ReservationProvider>
        </DinoDialog>

        <DinoDialog open={modifyTimeOpen}
                    title='Időpont módosítása'
                    subtitle='Válassz időpontot!'
                    actions={modifyActions}
                    handleClose={() => setModifyTimeOpen(false)}>
            <SelectOnlyDate reservationData={reservation} setNewDate={setNewDate}/>
        </DinoDialog>

        <DinoDialog open={billingOpen}
                    title='Számla kiállítása'
                    subtitle='A kiállítás előtt módosíthatod az adatokat'
                    actions={billingActions}
                    handleClose={() => setBillingOpen(false)}>
            <InvoiceAdditionalData reference={billingRef}/>
        </DinoDialog>

        <SpeedDial
            ariaLabel="Foglalások kezelése"
            sx={{display: {sm: 'flex', md: 'none'}, position: 'fixed', bottom: 16, right: 16}}
            icon={<SpeedDialIcon style={{color: '#fff'}}/>}
        >
            {buttons?.map((action) => (
                <SpeedDialAction
                    key={action.name}
                    icon={action.props?.endIcon || action.props?.startIcon}
                    onClick={action.props?.onClick}
                    tooltipTitle={action.name}
                />
            ))}
        </SpeedDial>

    </AuthBase>
}

export default Reservations